import { ChangeLog, ChangeLogView } from "src/components/change-log/ChangeLog";
import { useRouteParams } from "src/hooks/useRouteParams";

export function DevelopmentChangeLogPage() {
  const { developmentId } = useRouteParams<{ developmentId: string }>();

  return <ChangeLog view={ChangeLogView.Development} developmentId={developmentId} />;
}
